<div
  class="attachment-preview-dialog"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="current.file_name"
>
  <div class="preview-actions">
    <button
      mat-icon-button
      type="button"
      (click)="download()"
      aria-label="Download {{ current.file_name }}"
      data-testid="download-preview-button"
    >
      <mat-icon>download</mat-icon>
    </button>
    <button
      mat-icon-button
      type="button"
      (click)="close()"
      aria-label="Close preview"
      data-testid="close-preview-button"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="preview-body">
    @if (hasMultiple) {
      <button
        mat-icon-button
        class="nav-btn prev"
        type="button"
        (click)="prev()"
        aria-label="Previous attachment"
        data-testid="preview-prev-button"
      >
        <mat-icon>chevron_left</mat-icon>
      </button>
    }

    <div class="preview-content">
      @if (isImage) {
        <img [src]="current.url" [alt]="current.file_name" data-testid="preview-image" />
      } @else if (isPdf) {
        <iframe [src]="safePdfUrl" [title]="current.file_name" data-testid="preview-pdf"></iframe>
      }
    </div>

    @if (hasMultiple) {
      <button
        mat-icon-button
        class="nav-btn next"
        type="button"
        (click)="next()"
        aria-label="Next attachment"
        data-testid="preview-next-button"
      >
        <mat-icon>chevron_right</mat-icon>
      </button>
    }
  </div>

  <p class="preview-filename">{{ current.file_name }}</p>
</div>
